//React Components and Hooks
import { can } from "modules/settings/accessRoles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
//Material UI Components and Functions
import AppBar from "@mui/material/AppBar";
import Snackbar from "@mui/material/Snackbar";
import { makeStyles } from "@mui/styles";
import { useTheme } from "@mui/material/styles";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { DataGridPro } from "@mui/x-data-grid-pro";
import MuiAlert from "@mui/material/Alert";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  fetchPreviousMeterReadingUploads,
  handleError,
  handleMeterReadingsUploadSubmission,
  receivedReadingsSubmission,
  deleteMeterReadingUpload,
  markMeterReadingUploadAsBilled
} from "../../modules/readings-uploads/api/actions";
import csvToArray from "./helpers/csvToArray";
import _ from "lodash"
import "./index.css";
import UploadsTable from "./UploadsTable";
import { styled } from '@mui/material/styles';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

// Safe Transition component that doesn't access scrollTop
// This prevents errors when the container becomes null during dialog unmount
const SafeTransition = React.forwardRef(function SafeTransition(props, ref) {
  const { in: inProp, children } = props;
  
  // Simple fade-in without accessing scrollTop
  const [opacity, setOpacity] = useState(0);
  
  useEffect(() => {
    if (inProp) {
      // Use requestAnimationFrame to avoid accessing scrollTop
      requestAnimationFrame(() => {
        setOpacity(1);
      });
    } else {
      setOpacity(0);
    }
  }, [inProp]);
  
  return (
    <div
      ref={ref}
      style={{
        opacity: opacity,
        transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      }}
    >
      {children}
    </div>
  );
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`action-tabpanel-${index}`}
      aria-labelledby={`action-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box pt={3} pl={-1}>
          {children}
        </Box>
      )}
    </Typography>
  );
}

TabPanel.propTypes = {
  user: PropTypes.object.isRequired,
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `action-tab-${index}`,
    "aria-controls": `action-tabpanel-${index}`,
  };
}


function csvJSON(csv){

  var lines=csv.split("\n");

  var result = [];

  var headers=lines[0].split(",");

  for(var i=1;i<lines.length;i++){

	  var obj = {};
	  var currentline=lines[i].split(",");

	  for(var j=0;j<headers.length;j++){
		  obj[headers[j]] = currentline[j];
	  }

	  result.push(obj);

  }
  
  //return result; //JavaScript object
  return result //JSON
}

const useStyles = makeStyles({});

const Input = styled('input')({
  display: 'none',
});

const MeterReadingsUpload = (props) => {
  const classes = useStyles();
  const theme = useTheme();

  const [value, setValue] = useState(0);
  const [file, setFile] = useState({});
  const [csvData, setCsvData] = useState({ rows: [], columns: [] });
  const [recentFile, setRecentFile] = useState("");
  const [successState, setSuccessState] = useState(false);

  const getUploads = () => {
    try {
      props.fetchPreviousMeterReadingUploads();
    } catch (err) {
      props.handleError(err);
    }
  };
  

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSuccess = () => {
    setSuccessState(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSuccessState(false);
    props.handleError(null); 
  };

  const fileInputChange = (e) => {
    let fileTypeRegEx = /(?:\.([^.]+))?$/;
    let fileType = fileTypeRegEx.exec(e.target.files[0].name)[1];

    if (fileType !== "csv") {
      props.handleError({ message: "Please upload a csv file." });
    } else {
      setFile(e.target.files[0])
      var file = e.target.files[0];
        var reader = new FileReader();
        reader.onload = function(e) {
          // The file's text will be printed here
          console.log(e.target.result)
          let result = csvJSON(e.target.result)
          if(result.length > 1000){
            props.handleError({ message: "csv file must have less than 1000 records." });
            return;
          }
          let formatted = []
          formatted = formatData(result);
          console.log(formatted)
  
          setCsvData(formatted);
        };

        reader.readAsText(file);
    };
  };

  const submitReadingsUpload = (e) => {
    e.preventDefault();

    let reader = new FileReader();

    reader.onload = async function (evt) {
      try {
        let data = csvToArray(evt.target.result);
        // props.receivedReadingsSubmission(data); // if we implement preview feature
        let result = await props.handleMeterReadingsUploadSubmission(
          data,
          data[0],
          file.name
        );
        if (result?.error == true) {
          // The API action already dispatches HANDLE_ERROR, so error is already in Redux
        } else {
          handleSuccess(`Successfully Uploaded ${result.length} meter reads.`);
          setCsvData({ rows: [], columns: [] });
          props.fetchPreviousMeterReadingUploads();
          setRecentFile(file.name);
        }

        
      } catch (err) {
        props.handleError(err);
      }
    };

    reader.readAsText(file);
  };

  useEffect(() => {
    getUploads();
  }, []);

  const formatData = (datas, caseChange) => {
    const keys = Object.keys(datas[0]);
    let output = keys.map((key) => {
      return {
        field: key,
        editable: false,
        width: 200,
        headerName: (caseChange) ? _.startCase(key) : key
      };
    });

    datas.forEach(function (element, index) {
      element.id = index + 1;
    });
    return { rows: datas, columns: output };
  };


  // Get error message from Redux state
  const displayErrorMessage = props.meterReadingsUpload.error?.message || 
    (props.meterReadingsUpload.error?.data?.message) ||
    "An error occurred";

  return (
    <Box className={classes.root} sx={{ width: '100%' }}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={successState}
        autoHideDuration={6000}
        onClose={handleClose}
        TransitionComponent={SafeTransition}
      >
        <Alert onClose={handleClose} severity="success">
          Successfully submitted meter upload.
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={!!props.meterReadingsUpload.error}
        autoHideDuration={6000}
        onClose={handleClose}
        TransitionComponent={SafeTransition}
      >
        <Alert onClose={handleClose} severity="error">
          {displayErrorMessage}
        </Alert>
      </Snackbar>

      <AppBar position="static" color="primary">
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="meter readings tabs"
          sx={{
            '& .MuiTab-root': {
              color: 'rgba(255, 255, 255, 0.7)',
              fontWeight: 500,
              textTransform: 'none',
              '&:hover': {
                color: 'rgba(255, 255, 255, 0.9)'
              },
              '&.Mui-selected': {
                color: '#ffffff',
                fontWeight: 600
              }
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#d67104',
              height: 3
            }
          }}
        >
          <Tab label="Upload Meter Readings" {...a11yProps(0)} />
          <Tab label="Previous Meter Reading Uploads" {...a11yProps(1)} />
        </Tabs>
      </AppBar>

      <Box sx={{ width: '100%' }}>
        <TabPanel value={value} index={0} dir={theme.direction}>
          <form method="post" action="#" id="#">
            <div className="meter-readings-upload-form-container">
              <div className="meter-readings-upload-form">

              <input
              className={classes.input}
              style={{ display: 'none' }}
              onChange={fileInputChange}
              id="raised-button-file"
              multiple=""
              type="file"
            />
            <label htmlFor="raised-button-file">
              <Button color="primary" variant="contained" component="span">
                Upload
              </Button>
            </label> 
              </div>
              {csvData.rows.length > 0 &&
              <Button
                classes={classes.root}
                disabled={
                  props.meterReadingsUpload.isLoading ||
                  recentFile == file.name
                }
                variant="contained"
                color="secondary"
                onClick={submitReadingsUpload}
              >
                {props.meterReadingsUpload.isLoading  ? (
                  <CircularProgress color="inherit" />
                ) : (
                  "Submit"
                )}
              </Button> }
            </div>
          </form>

          <div style={{ height: 850, width: "100%" }}>            
          <DataGridPro
              {...csvData}
              rowHeight={38}
  
            />
          </div>
        </TabPanel>

        <TabPanel value={value} index={1} dir={theme.direction}>
          <UploadsTable
            uploads={
              props.meterReadingsUpload.data.previousMeterReadingUploads
            }
            canDelete={can(props.user.details, "meterReadings")}
            handleUploadDelete={props.deleteMeterReadingUpload}
            markMeterReadingUploadAsBilled={props.markMeterReadingUploadAsBilled}
          />
        </TabPanel>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    meterReadingsUpload: state.meterReadingsUpload,
    user: state.user
  };
};

export default connect(mapStateToProps, {
  handleMeterReadingsUploadSubmission,
  receivedReadingsSubmission,
  handleError,
  fetchPreviousMeterReadingUploads,
  deleteMeterReadingUpload,
  markMeterReadingUploadAsBilled
})(MeterReadingsUpload);
